import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams, MenuController, ModalController } from 'ionic-angular';
import { Chart } from "chart.js";
import { ClubsPage } from '../clubs/clubs';
import { LunchrouletteEmployerPage } from '../lunchroulette/lunchroulette';
import { TeambuildingEmployerPage } from '../teambuilding/teambuilding';
import { RhEmployerPage } from '../rh/rh';
import { SondageEmployerPage } from '../sondage/sondage-employer';
import { GeneralEmployerPage } from '../general/general';




@IonicPage()
@Component({
  selector: 'page-dashboard',
  templateUrl: 'dashboard.html',
})
export class DashboardPage {

  tabEmployer1 = GeneralEmployerPage;
  tabEmployer2 = ClubsPage;
  tabEmployer3 = TeambuildingEmployerPage;
  tabEmployer4 = RhEmployerPage;
  tabEmployer5 = SondageEmployerPage;



  constructor(public navCtrl: NavController, public navParams: NavParams, menu: MenuController, public modalCtrl: ModalController) {
    
  }

  ionViewDidLoad() {

  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/pages/employer/dashboard/dashboard.ts